import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { ImageViewer } from './image-viewer-dialog.model';

@Component({
    selector: 'app-image-viewer-dialog',
    templateUrl: './image-viewer-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NgTemplateOutlet, MatDialogModule, NgIf, NgFor, MatButtonModule],
    styleUrls: ['./image-viewer-dialog.component.scss'],
})
export class ImageViewerDialogComponent {
    current = 0;
    images = [];
    constructor(
        public dialogRef: MatDialogRef<ImageViewerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ImageViewer,
        public dialog: MatDialog
    ) {}

    ngOnInit() {
        this.current = this.data.current;
        this.images = this.data.blobImages ??  this.data.images;
    }

    get isLast() {
        return this.current == (this.images.length - 1);
    }

    get isFirst() {
        return this.current == 0;
    }

    toSlide(type) {
        switch (type) {
            case 'next':
                return this.current = this.isLast ? 0 : (this.current + 1);
            case 'prev':
                return this.current = this.isFirst ? (this.images.length - 1) : (this.current - 1);
            default:
                return this.current = type;
        }
    }
}
